import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";

// #202-T4: Attachment-Verwaltung (Admin-Cleanup). direction wird serverseitig
// aus targetAgentId abgeleitet (inbound = Channel→Agent, outbound = Agent→Channel).
export interface AttachmentRow {
  id: string;
  filename: string;
  mimetype: string;
  size: number;
  ownerAgentId: string;
  targetAgentId: string | null;
  channelId: string | null;
  direction: "inbound" | "outbound";
  createdAt: string;
}

export interface AttachmentFilter {
  ownerAgentId?: string;
  channelId?: string;
  direction?: "inbound" | "outbound";
  mimetypePrefix?: string;
  filenameContains?: string;
  createdAfter?: string;
  createdBefore?: string;
  limit?: number;
  offset?: number;
}

export interface AttachmentPage {
  items: AttachmentRow[];
  total: number;
  limit: number;
  offset: number;
}

function buildQuery(f: AttachmentFilter): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(f)) {
    if (v !== undefined && v !== "" && v !== null) p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : "";
}

export function useAttachments(filter: AttachmentFilter): UseQueryResult<AttachmentPage> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: [...queryKeys.list("attachments"), filter],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<AttachmentPage>(`/attachments${buildQuery(filter)}`);
    },
    enabled: !!session,
  });
}
